import { useMemo } from 'react';

import { MessagingPlatform, UserCommunication } from '@this+that/models';

import { useTeamsIntegrations } from './useTeamsIntegrations';

export function useTeamsHomeAccountId(
  communication: UserCommunication,
): string | undefined {
  const teamsIntegrations = useTeamsIntegrations();

  return useMemo(() => {
    if (communication.platform !== MessagingPlatform.TEAMS) {
      return undefined;
    }

    const userEmailAddress = communication.userEmailAddress;
    if (!userEmailAddress) {
      return undefined;
    }

    // getHomeAccountId (utils/integrationAccountHelpers.ts) falls back to the email
    // address when no match is found, which is wrong for Teams-enabled/Outlook-disabled
    // accounts — matching here must stay strict and return undefined instead.
    const matchingIntegration = teamsIntegrations.find(
      (integration) =>
        integration.outlookAddress.toLowerCase() ===
        userEmailAddress.toLowerCase(),
    );

    return matchingIntegration?.homeAccountId;
  }, [
    communication.platform,
    communication.userEmailAddress,
    teamsIntegrations,
  ]);
}
